const PAYMENT_PROVIDER = {
  Undefined: "Undefined",
  Payrexx: "Payrexx",
  Coinify: "Coinify"
};

export default PAYMENT_PROVIDER
